import { config } from 'gemini-config';
import { createProgressParams, FormDataUtils, getNetworkService, prefixUrl } from 'GeminiViewerComponent/helpers';
import { getAccountService } from 'GeminiViewerComponent/features/services/account.service';

const accountService = getAccountService({ config: config });
const networkService = getNetworkService({
    config: config,
    checkAuth: accountService.checkAuth,
});
const baseUrl = `${config.apiUrl}/part/category`;

const mapCategory = (category, s3Prefix) => {
    if (category?.image_url) {
        category.image_url = prefixUrl(category.image_url, s3Prefix);
    }
    return category;
};

const mapCategories = (categories, s3Prefix) => {
    return categories.map((category) => {
        return mapCategory(category, s3Prefix);
    });
};

const getPartCategories = async (searchString = '', sort = '-display_name', s3Prefix = '', activeOnly = true) => {
    const filters = [`is_active==${activeOnly.toString()}`, `display_name@=*${searchString}`];
    const params = {
        filters: filters.join(','),
        sorts: sort,
    };
    const query = new URLSearchParams(params).toString();
    try {
        const response = await networkService.get(`${baseUrl}?${query}`);
        response.data = mapCategories(response?.data, s3Prefix);
        const pageInfo = response.headers['x-pagination'];
        return {
            pageInfo: pageInfo,
            categories: response?.data,
        };
    } catch (e) {
        return Promise.reject(e.error);
    }
};

const create = async (params, s3Prefix = '') => {
    const user = JSON.parse(localStorage.getItem('user'));
    let formData = new FormData();
    FormDataUtils.safeAppend(formData, [
        ['display_name', params.display_name],
        ['client_id', user.client_id],
        ['image', params.image],
    ]);
    let progressParams = createProgressParams(params);
    try {
        const response = await networkService.postMultiFormData(baseUrl, formData, progressParams);
        response.data = mapCategory(response.data, s3Prefix);
        return response.data;
    } catch (e) {
        return Promise.reject(e.error);
    }
};

const update = async (params, s3Prefix = '') => {
    const user = JSON.parse(localStorage.getItem('user'));
    let formData = new FormData();
    FormDataUtils.safeAppend(formData, [
        ['display_name', params.display_name],
        ['client_id', user.client_id],
        ['image', params.image],
        ['image_url', params.image_url],
    ]);
    let progressParams = createProgressParams(params);
    try {
        const response = await networkService.putMultiFormData(
            `${baseUrl}/${params.part_category_id}`,
            formData,
            progressParams
        );
        response.data = mapCategory(response.data, s3Prefix);
        return response.data;
    } catch (e) {
        return Promise.reject(e.error);
    }
};

const _delete = async (part_category_id) => {
    try {
        const response = await networkService.delete(`${baseUrl}/${part_category_id}`);
        return response;
    } catch (e) {
        return Promise.reject(e.error);
    }
};

const getById = async (id, s3Prefix = '') => {
    const response = await networkService.get(`${baseUrl}/${id}`);
    return mapCategory(response.data, s3Prefix);
};

export const partCategoryService = {
    getPartCategories,
    getById,
    create,
    update,
    delete: _delete,
};
